// src/api/formationContinue.js
import { CONFIG } from '../config/config';

function authHeaders() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
}

export async function listQuestions() {
  const r = await fetch(`${CONFIG.API_URL}/formation-continue`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return await r.json();
}

export async function getQuestionToAnswer(id, role) {
  const r = await fetch(`${CONFIG.API_URL}/formation-continue/qta/${id}?role=${role}`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return await r.json();
}

export async function updateQuestion(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/formation-continue/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function uploadQuestionsFile(file) {
  const formData = new FormData();
  formData.append('file', file);

  const r = await fetch(`${CONFIG.API_URL}/formation-continue`, {
    method: 'POST',
    headers: {
      Authorization: authHeaders().Authorization,
    },
    body: formData,
  });

  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function answerQuestion(payload) {
  const r = await fetch(`${CONFIG.API_URL}/formation-continue/answer`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}
